import axios from 'axios';
import { handleTokenExpiry } from './tokenExpiredNotification';


// 기본 URL 설정
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
  withCredentials: true,
});

// 요청 인터셉터 설정
// JWT는 httpOnly 쿠키로 자동 전송됩니다 (withCredentials: true).
// CSRF 토큰만 헤더에 추가합니다.
instance.interceptors.request.use(
  (config) => {
    const csrfToken = localStorage.getItem('csrf_token');

    if (csrfToken) {
      config.headers['X-CSRF-Token'] = csrfToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 응답 인터셉터 설정
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 네트워크 에러 (서버에 도달하지 못한 경우)
    if (!error.response) {
      if (error.code === 'ECONNABORTED') {
        error.userMessage = '요청 시간이 초과되었습니다. 네트워크 상태를 확인해 주세요.';
      } else {
        error.userMessage = '네트워크에 연결할 수 없습니다. 인터넷 연결을 확인해 주세요.';
      }
      return Promise.reject(error);
    }

    // 로그인/OTP/인증확인 경로에서 발생한 에러는 전역 처리에서 제외
    const publicPaths = ['/auth/admin/login', '/auth/admin/verify-otp', '/auth/me'];
    if (error.config && publicPaths.some(path => error.config.url.endsWith(path))) {
      // 컴포넌트의 catch 블록에서 처리하도록 에러를 그대로 반환
      return Promise.reject(error);
    }

    // 401 오류 (인증 실패) 또는 403 오류 (권한 없음) 처리
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // 에러 메시지에서 토큰 만료 관련 키워드 확인
      const errorMessage = error.response.data?.message || error.response.data?.error || '';
      const isTokenExpiry = errorMessage.toLowerCase().includes('token') ||
                           errorMessage.toLowerCase().includes('expired') ||
                           errorMessage.toLowerCase().includes('unauthorized') ||
                           error.response.status === 401;

      if (isTokenExpiry) {
        handleTokenExpiry();
        return Promise.reject(new Error('Token expired'));
      }
    }

    // 토큰 없음이나 유효하지 않은 토큰으로 인한 일반적인 401/403 에러
    if (error.response && error.response.status === 401) {
      handleTokenExpiry();
      return Promise.reject(new Error('Authentication failed'));
    }

    // 500번대 서버 에러
    if (error.response && error.response.status >= 500) {
      error.userMessage = '서버에 문제가 발생했습니다. 잠시 후 다시 시도해 주세요.';
    }

    return Promise.reject(error);
  }
);

export default instance;
